import { render, staticRenderFns } from "./AccountLockedForm.vue?vue&type=template&id=382b2703&scoped=true&"
import script from "./AccountLockedForm.vue?vue&type=script&lang=ts&"
export * from "./AccountLockedForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountLockedForm.vue?vue&type=style&index=0&id=382b2703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382b2703",
  null
  
)

export default component.exports